<template>
  <button class="btn btn-primary" type="button" @click="createModal.show()">
    <i class="fa fa-plus"> Adicionar Regla</i>
  </button>

  <div
    class="modal fade"
    ref="eventModal"
    id="exampleModalCenter"
    tabindex="-1"
    role="dialog"
    aria-labelledby="exampleModalCenter"
    aria-hidden="true"
  >
    <div class="modal-dialog modal-dialog-centered" role="document">
      <vee-form :validation-schema="placeSchema" @submit="registerPlace">
        <div class="modal-content">
          <div class="modal-header">
            <h5 class="modal-title">Crear Categoric</h5>
            <button
              class="btn-close"
              type="button"
              @click="createModal.hide()"
              aria-label="Close"
            ></button>
          </div>
          <div class="modal-body">
            <div class="row">
              <div class="col-12">
                <div class="mb-3">
                  <label>Regla</label>
                  <vee-field class="form-control" name="rule" type="text" />
                  <ErrorMessage class="text-danger" name="rule" />
                </div>
              </div>
            </div>
          </div>
          <div class="modal-footer">
            <button
              class="btn btn-secondary"
              type="button"
              data-bs-dismiss="modal"
            >
              Cancelar
            </button>
            <button class="btn btn-primary" type="submit">Registrar</button>
          </div>
        </div>
      </vee-form>
    </div>
  </div>
</template>

<script setup>
import { ref, onMounted, inject } from "vue";
import axios from "@/includes/connection";
import { Modal } from "bootstrap";

const swal = inject("$swal");
const createEventModal = ref(null);
const emits = defineEmits(["reload-list"]);

onMounted(() => {
  loadSystems();
});

function registerPlace(values, { resetForm }) {
  swal
    .fire({
      title: "¿Esta seguro?",
      text: "Se registrara el nuevo registro?.",
      icon: "warning",
      showCancelButton: true,
      confirmButtonColor: "#3085d6",
      cancelButtonColor: "#d33",
      confirmButtonText: "Registrar",
      cancelButtonText: "Cancelar",
    })
    .then((result) => {
      if (result.isConfirmed) {
        console.log("values for place >> ", values);
        axios
          .post("/criteria", values)
          .then((response) => {
            console.log("response", response);
            resetForm();
            swal
              .fire({
                title: "Registro Exitoso!!!",
                text: "Se registro de manera exitosa",
                icon: "success",
              })
              .then((result) => {
                if (result.isConfirmed) {
                  emits("reload-list");
                  createModal.hide();
                }
              });
          })
          .catch(function (error) {
            console.log(error);
            swal.fire({
              title: "Registro fallido!!!",
              text: "No se pudo registrar",
              icon: "warning",
            });
          });
      }
    });
}

const system_edu = ref();
const levelList = ref([]);
function changeSystem() {
  let load = systemList.value.find((el) => {
    if (el.id == system_edu.value) {
      return el;
    }
  });
  console.log("load levels list ", load);
  levelList.value = load.level;
  console.log("selected system", levelList.value);
}

const systemList = ref([]);
function loadSystems() {
  axios
    .get("/institution-type")
    .then((response) => {
      console.log("loadItems systems", response.data);
      systemList.value = response.data;
    })
    .catch(function (error) {
      console.log(error);
    });
}

const eventModal = ref(null);
let createModal = null;
onMounted(() => {
  createModal = new Modal(eventModal.value);
});

const placeSchema = {
  rule: "required",
};
</script>
